<template>
  <div
    id="track-seekbar"
    data-track-seekbar
    class="
      @768/layout/height
      layout/height
      layout/margin:left:cap:2
      layout/margin:right:cap:2
      layout/relative
      layout/width:100%
    "
    style="
      --768--layout--height: 4.4rem;
      --layout--height: 3.6rem;
    "
    >
    <div
      ref="seekbar"
      data-seekbar
      :style="{ background: offsetProgressGradient }"
      @click="onClick"
    />
    <div
      data-scrubber
      :style="{ left: offsetPercent }"
      @mousedown.prevent="onMouseDown"
    />
  </div>
</template>

<script>
  export default {
    props: {
      currentTime: { type: Number, required: true },
      duration: { type: Number, required: true },
    },
    data() {
      return {
        colorSliderLeft: '#FFF',
        colorSliderRight: '#888',
        offsetPercent: '0%',
        offsetProgressGradient: '',
        seekbarOffsetLeft: 0,
        seekbarWidth: 0,
      };
    },
    watch: {
      currentTime(newValue) {
        const percentage = (newValue / this.duration) * 100;
        this.updateScrubberPosition(percentage, newValue);
      },
    },
    mounted() {
      this.seekbarOffsetLeft = this.$refs.seekbar.getBoundingClientRect().left;
      this.seekbarWidth = this.$refs.seekbar.clientWidth;
    },
    methods: {
      onClick(e) {
        const position = e.pageX - this.seekbarOffsetLeft;
        if (position <= 0 || position >= this.seekbarWidth) return;

        const percentage = (position / this.seekbarWidth) * 100;
        const clickedToSecond = (this.duration / 100) * percentage;
        this.updateScrubberPosition(percentage, clickedToSecond);

        this.$emit('click-to', { seconds: clickedToSecond });
      },
      onMouseDown() {
        document.body.style.cursor = 'grab';
        window.addEventListener('mouseup', this.onMouseUp);
        window.addEventListener('mousemove', this.onMouseMove);
      },
      onMouseMove(e) {
        const position = e.pageX - this.seekbarOffsetLeft;
        if (position <= 0 || position >= this.seekbarWidth) return;

        const percentage = (position / this.seekbarWidth) * 100;
        const scrubbedToSecond = (this.duration / 100) * percentage;
        this.updateScrubberPosition(percentage, scrubbedToSecond);

        this.$emit('scrub-to', { seconds: scrubbedToSecond });
      },
      onMouseUp() {
        document.body.style.cursor = 'auto';
        window.removeEventListener('mouseup', this.onMouseUp);
        window.removeEventListener('mousemove', this.onMouseMove);
      },
      updateScrubberPosition(offsetPercentage) {
        this.offsetPercent = `${offsetPercentage}%`;
        this.offsetProgressGradient = `
          linear-gradient(
            to right,
            ${this.colorSliderLeft} 0%, ${this.colorSliderLeft} ${this.offsetPercent},
            ${this.colorSliderRight} ${this.offsetPercent}, ${this.colorSliderRight} 100%
          )`;
      },
    },
  };
</script>

<style scoped>
  [data-seekbar] {
    border-bottom-width: 1.7rem;
    border-color: #333;
    border-style: solid;
    border-top-width: 1.7rem;
    cursor: pointer;
    height: 100%;
    width: 100%;
  }

  @media (min-width: 768px) {
    [data-seekbar] {
      border-bottom-width: 2.1rem;
      border-top-width: 2.1rem;
    }
  }

  [data-scrubber] {
    height: 3.6rem;
    margin-left: -2.0rem;
    margin-top: -3.6rem;
    position: absolute;
    width: 4.0rem;
  }

  @media (min-width: 768px) {
    [data-scrubber] {
      height: 4.4rem;
      margin-left: -2.4rem;
      margin-top: -4.4rem;
      width: 4.8rem;
    }
  }

  [data-scrubber]:after {
    background-color: #fff;
    border-radius: 50%;
    content: '';
    display: block;
    height: 1.2rem;
    left: 50%;
    margin-left: -0.6rem;
    margin-top: -0.6rem;
    position: absolute;
    top: 50%;
    width: 1.2rem;
  }
</style>
